import React from 'react';
import { Stack, Grid } from '@mui/material';
import InputLabel from 'components/form/InputLabel';
import ControlledAutocomplete from 'components/form/Autocomplete';

const DadosCredenciais = ({ formProps, credenciaisBradesco, credenciaisItau, credenciaisSantander, disabled }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Stack spacing={0}>
          <InputLabel htmlFor="credencialBradesco">Credencial Bradesco</InputLabel>
          <ControlledAutocomplete
            formProps={formProps}
            name="credencialBradesco"
            domain={credenciaisBradesco}
            idField="id"
            labelField="descricao"
            noOptionsText="Nenhuma credencial encontrada"
            disabled={disabled}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={4}>
        <Stack spacing={0}>
          <InputLabel htmlFor="credencialItau">Credencial Itau</InputLabel>
          <ControlledAutocomplete
            formProps={formProps}
            name="credencialItau"
            domain={credenciaisItau}
            idField="id"
            labelField="descricao"
            noOptionsText="Nenhuma credencial encontrada"
            disabled={disabled}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={4}>
        <Stack spacing={0}>
          <InputLabel htmlFor="credencialSantander">Credencial Santander</InputLabel>
          <ControlledAutocomplete
            formProps={formProps}
            name="credencialSantander"
            domain={credenciaisSantander}
            idField="id"
            labelField="descricao"
            noOptionsText="Nenhuma credencial encontrada"
            disabled={disabled}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default DadosCredenciais;
